var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('OpenDownIcon',{class:_vm.clsx('popup-toggle', { 'popup-toggle--open': _vm.isOpen }),attrs:{"color":_vm.calculateTogglerColor}})}
var staticRenderFns = []

export { render, staticRenderFns }